import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class StocklistSpecsEdit {
  constructor($scope, $rootScope, ProductService) {
    function set_product_autocomplete(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          ProductService.search_products_by_title(request.term).then(function(data) {
            response(data.products);
          });
        },
        select: function(event, ui) {
          if (!_.findWhere($scope.spec.epaper_products, {id: ui.item.id}))
            $scope.spec.epaper_products.push({
              id: ui.item.id,
              title: ui.item.value
            });
          $(this).val('');
          $scope.$apply();
          return false;
        }
      });
    }

    function set_product_group_autocomplete(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          ProductService.search_product_groups_by_title(request.term).then(function(data) {
            response(data.groups);
          });
        },
        select: function(event, ui) {
          if (!_.findWhere($scope.spec.groups, {id: ui.item.id}))
            $scope.spec.groups.push({
              id: ui.item.id,
              title: ui.item.value
            });
          $(this).val('');
          $scope.$apply();
          return false;
        }
      });
    }

    $scope.add_product_name = function() {
      if (!_.contains($scope.spec.product_names, $scope.product_name)) {
        $scope.spec.product_names.push($scope.product_name);
      }
      $scope.product_name = null;
    };

    $scope.remove_product_name = function(product_name) {
      $scope.spec.product_names = _.reject($scope.spec.product_names, function(name) {
        return name == product_name;
      });
    };

    $scope.open_dialog = function(dialog_id) {
      if (($scope.filter.supplier_id && $scope.filter.date_from && $scope.filter.date_to) || window.offer) {
        $scope.load_dialog_products();
        $.fancybox($('div#' + dialog_id), {
          padding: '5',
          openEffect: 'elastic',
          closeEffect: 'elastic',
          openSpeed: '700',
          closeSpeed: '300',
          topRatio: 0.15,
          scrolling: 'yes'
        });
      } else {
        alert('Please select a supplier and date period!');
      }
    };

    $scope.load_dialog_products = function() {
      $scope.dialog_products = [];
      $scope.dialog_products_checked = false;
      $scope.loading_dialog_products = true;
      ProductService.search_products_by_filter($scope.filter).then(function(data) {
        if (data.success)
          $scope.dialog_products = data.products;
        $scope.loading_dialog_products = false;
      });
    };

    $scope.check_dialog_products = function() {
      angular.forEach($scope.dialog_products, function(product) {
        product.checked = $scope.dialog_products_checked;
      });
    };

    $scope.add_selected_products = function() {
      var products = _.select($scope.dialog_products, function(p) {
        return p.checked === true;
      });
      if (products.length === 0) {
        alert('Please select at least one product!');
      } else {
        angular.forEach(products, function(product) {
          if (!_.findWhere($scope.spec.epaper_products, {id: product.id}))
            $scope.spec.epaper_products.push({
              id: product.id,
              title: product.name
            });
        });
        $.fancybox.close();
      }
    };

    $scope.remove_epaper_product = function(product_id) {
      $scope.spec.epaper_products = _.reject($scope.spec.epaper_products, function(product) {
        return product.id == product_id;
      });
      $('input.epaper_product').val('');
    };

    $scope.dialog_quick_search = function() {
      window.filter_table('table#dialog_products', $scope.dialog_query);
    };

    $scope.roundQuantity = function(quantity) {
      return window.roundToTwo(quantity);
    };

    $scope.$watch('categories', function() {
      if (!$scope.categories_clone) {
        $scope.categories_clone = angular.copy($scope.categories);
        set_categories();
      }
    });

    function set_categories() {
      _.each($scope.spec.categories, function(category_id) {
        var category = _.findWhere($scope.categories_clone, {
          id: category_id
        });
        if (category) {
          category.checked = true;
        }
      });
    }

    $scope.update_categories = function(category) {
      if (category.checked) {
        if (!_.contains($scope.spec.categories, category.id)) {
          $scope.spec.categories.push(category.id);
        }
      } else {
        $scope.spec.categories = _.without($scope.spec.categories, category.id);
      }
    };

    $scope.open_group_dialog = function() {
      var data = {
        categories: $scope.categories_clone,
        selected_groups: $scope.spec.groups,
      };

      $rootScope.$broadcast('show_product_category_specs_groups', data);
    };

    $scope.$on('product_category_specs_groups_update', function(event, data) {
      $scope.spec.groups = data.groups;
      console.log(data.groups);
    });

    $scope.remove_group = function(group_id) {
      $scope.spec.groups = _.reject($scope.spec.groups, function(group) {
        return group.id == group_id;
      });
      $('input.group').val('');
    };

    $scope.add_item_specs = function() {
      $scope.spec.item_specs.push({});
    };

    $scope.delete_item_spec = function(item_spec) {
      $scope.spec.item_specs.splice(_.indexOf($scope.spec.item_specs, item_spec), 1);
    };

    $scope.init = function() {
      if (!$scope.spec.product_names) {
        $scope.spec.product_names = [];
      }

      if (!$scope.spec.epaper_products) {
        $scope.spec.epaper_products = [];
      }

      if (!$scope.spec.categories) {
        $scope.spec.categories = [];
      }

      if (!$scope.spec.groups) {
        $scope.spec.groups = [];
      }

      if (!$scope.spec.item_specs) {
        $scope.spec.item_specs = [];
      }

      if (!$scope.categories_clone && $scope.categories &&
        $scope.categories.length > 0) {
        $scope.categories_clone = angular.copy($scope.categories);
        set_categories();
      }

      set_product_autocomplete($('input.epaper_product'));
      set_product_group_autocomplete($('input.group'));
    };

    $scope.init();

  }
}

StocklistSpecsEdit.$inject = ['$scope', '$rootScope', 'ProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/stocklist-specs-edit.ctrl.js